import { css, cx } from 'emotion';
import {
	textBlock,
	lightGrey,
	headingMediumLight,
	mobileMaxWidthBreakpoint,
	audienceStylesHash,
} from 'inside-out/global-styles';

const padding = 24;

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'block',
});

export const metaAudiencesStyle = css({
	marginBottom: '12px',
	'& span:not(:last-child)': {
		marginRight: '8px',
	},
});

export const lozengeStyle = id =>
	css({
		fontWeight: 500,
		fontSize: '10px',
		lineHeight: '12px',
		textTransform: 'uppercase',
		background: audienceStylesHash[id],
		color: '#fff',
		borderRadius: '11px',
		padding: '4px 8px',
		whiteSpace: 'nowrap',
		display: 'inline-block',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '8px',
			lineHeight: '10px',
		},
	});

export const titleStyle = cx(
	headingMediumLight,
	css({
		marginTop: '0',
		marginBottom: '4px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '14px',
			lineHeight: '17px',
		},
	})
);

export const innerStyleOrganisation = css({
	width: '130px',
	height: '130px',
	lineHeight: '130px',
	textAlign: 'center',
	marginRight: padding,
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	'& img': {
		maxWidth: '105px',
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		width: '80px',
		height: '80px',
		lineHeight: '80px',
		'& img': {
			maxWidth: '55px',
		},
	},
});

export const innerStyleIndividual = css({
	marginRight: padding,
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		marginRight: padding / 2,
	},
});

export const organisationStyle = css({
	color: '#8A8B8C',
	fontSize: '12px',
	lineHeight: '15px',
	marginBottom: '14px',
	'& img': {
		verticalAlign: 'middle',
	},
});

export const bodyStyle = cx(
	textBlock,
	css({
		margin: '0',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			display: 'none',
		},
	})
);

export const wrapperStyle = css({
	position: 'relative',
	textDecoration: 'none',
	border: `1px solid ${lightGrey}`,
	borderRadius: '6px',
	width: '100%',
	height: '100%',
	padding: `${padding}px`,
	backgroundColor: '#fff',
	boxSizing: 'border-box',
	display: 'table',
	zIndex: '1',
	'& > div': {
		verticalAlign: 'top',
		display: 'table-cell',
		'&:not(:empty):first-child': {
			width: '154px',
		},
	},
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		padding: `14px 14px 14px 14px`,
		'& > div': {
			'&:not(:empty):first-child': {
				width: '104px',
			},
		},
	},
});



// WEBPACK FOOTER //
// ./src/components/shared/cards/supportCard/styles.js